export const v1 = (() => {
  const v1 = {
    register: '/register',
    socialLogin: '/social_register',
    resetPassword: '/reset_password/send',
    gifts: '/gifts',
    redeemGift: '/gifts/redeem',
    mazeByStudentCode: (student_code: string, event?: string) => `/mazes?student_code=${student_code}${event ? `&event=${event}` : ''}`,
  }
  
  Object.keys(v1).forEach((key: keyof typeof v1) => {
    if (typeof v1[key] === 'string') {
      v1[key] = process.env.PUBLIC_API_URL + '/v1' + v1[key] as any
    } else {
      const orig = v1[key] as any;
      v1[key] = ((...args: any[]) => process.env.PUBLIC_API_URL + '/v1' + (orig)(...args)) as any
    }
  });

  return v1;
})();